export const GET_COMMISSIONS = "GET_COMMISSIONS";

export const GET_COMMISSION_TYPE = "commission/get?type=1"